<div class="row">
  <div class="col">
    <h1>{{'account_verify_failed_headline' | i18next}}</h1>
    <p>
      {{'account_verify_failed_content' | i18next}} <a routerLink="" (click)="tryAgain()" >{{'account_retry_signup' | i18next}}</a>
    </p>
  </div>
</div>
